// @preval
// Copyright (c) 2015-present, Salesforce, Inc. All rights reserved
// Licensed under BSD 3-Clause - see LICENSE.txt or git.io/sfdc-license

const Either = require("data.either");
const Immutable = require("immutable");
const theo = require("theo");
const path = require("path");
const findNodeModules = require("../helpers/findNodeModules");
const nodeModulesDir = findNodeModules(__dirname);

const sldsModule = "@salesforce-ux/design-system";

const tokenPath = path.resolve.bind(
  path,
  `${nodeModulesDir}/${sldsModule}/design-tokens`
);

const convert = (file) =>
  Immutable.fromJS({
    name: path.basename(file, ".yml"),
    tokens: JSON.parse(
      theo.convertSync({
        transform: {
          type: "web",
          file,
          includeMeta: true,
          includeRawValue: true,
        },
        format: {
          type: "raw.json",
        },
      })
    ),
  });

const clean = (tokenSet) =>
  tokenSet.updateIn(["tokens", "props"], (props) =>
    props.map((prop) => prop).toList()
  );

const rem2px = (value, baseFontPercentage = 100, baseFontPixel = 16) =>
  value.match(/rem$/)
    ? `${
        value.replace(/rem$/g, "") * baseFontPixel * (baseFontPercentage / 100)
      }px`
    : value;

const addPxValue = (tokenSet) =>
  tokenSet.updateIn(["tokens", "props"], (props) =>
    props.map((prop) =>
      prop.get("value").match(/rem(\s|$)/)
        ? prop.set(
            "pxValue",
            prop
              .get("value")
              .split(/\s+/)
              .map((value) => rem2px(value))
              .join(" ")
          )
        : prop
    )
  );

const indexOf = (all, name) =>
  all.findIndex((tokenSet) => tokenSet.get("name") === name);

const generate = () =>
  Either.of(true)
    .map(() =>
      Immutable.List([
        tokenPath("primitive.yml"),
        tokenPath("theme-one-salesforce.yml"),
        tokenPath("force-mq-commons.yml"),
        tokenPath("form-factor-large.yml"),
      ]).map(convert)
    )
    .map((all) => {
      const s1BaseIndex = indexOf(all, "ui-one");
      const s1BaseLargeIndex = indexOf(all, "form-factor-large");
      const s1BaseLarge = all.getIn([s1BaseLargeIndex, "tokens"]);

      return all.updateIn([s1BaseIndex, "tokens"], (tokens) =>
        Immutable.List.of("aliases", "props").reduce(
          (tokens, key) =>
            tokens.update(key, (items) =>
              items.map((item, itemKey) =>
                s1BaseLarge.get(key).has(itemKey)
                  ? s1BaseLarge.getIn([key, itemKey])
                  : item
              )
            ),
          tokens
        )
      );
    })
    .map((all) => all.map(clean).map(addPxValue))
    .get();

module.exports = generate();
